import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagRW = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M0 25c0 4.332 1.102 8.405 3.04 11.957L25 39.131l21.96-2.174A24.89 24.89 0 0 0 50 25l-25-2.173L0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M46.96 13.043C42.72 5.274 34.476 0 25 0S7.28 5.272 3.04 13.043A24.888 24.888 0 0 0 0 25h50c0-4.331-1.102-8.405-3.04-11.957Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M25 50c9.476 0 17.72-5.273 21.96-13.044H3.04C7.28 44.727 15.524 50 25 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m28.262 14.63 3.053 1.437-1.626 2.957 3.316-.634.42 3.349 2.309-2.463 2.31 2.463.42-3.35 3.315.635-1.626-2.957 3.053-1.436-3.053-1.436 1.626-2.957-3.316.634-.42-3.35-2.31 2.464-2.308-2.463-.42 3.349-3.316-.634 1.626 2.957-3.053 1.436Z"
}));
FlagRW.displayName = 'FlagRW';
export default withFlagWrapper(FlagRW);
//# sourceMappingURL=index.js.map